import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增报销项目")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 所有人 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, formatTime } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  'GET/invoice_expense_items': fetchList,
  // 角色列表
  'GET/roles': rolesListApi,
  // 创建报销项目
  'POST/invoice_expense_items': createdApi,
  // 删除报销项目
  'DELETE/invoice_expense_items/{id}': delApi,
  // 编辑项目
  'PATCH/invoice_expense_items': editApi,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

// 角色list
let rolesList = ref([]) 
onBeforeMount(() => {
  rolesListApi().then((_roles: any) => {
    rolesList.value = _roles
  })

  MI_params.key = 'ADMIN';
  fetchData()
})


// 添加
const isShowAdd = ref<boolean>(false)
const addConfig = ref([
  { 
    label: '项目名称',
    value: '',
    upKey: 'itemName',
    props: {maxlength: 100},
    rule: [{ required: true, message: '请输入项目名称', trigger: 'change' }],
  },
  {
    type: 'SELECT',
    label: '角色',
    value: [],
    upKey: 'roleId',
    options: rolesList,
    props: { multiple: true, 'collapse-tags': true, placeholder: '请选择角色' },
    seleProps: { label: 'name', valueName: 'id', }
  },
  {
    type: 'SELECT',
    label: '分摊类型',
    value: '',
    upKey: 'type',
    options: [
      {label: '不分摊', id: 'Empty'},
      {label: '订单', id: 'Order'},
      {label: '租赁', id: 'Lease'},
      {label: '提现', id: 'CTC'},
    ],
    props: { placeholder: '请选择是否分摊', clearable: true },
    rule: [{ required: true, message: '请选择是否分摊', trigger: 'change' }],
    seleProps: { label: 'label', valueName: 'id', }
  },
])
const addHandle = () => {
  MI_modifyForm({type: 'Empty'}, addConfig, isShowAdd, async(params: any) => {
    await createdApi(params)
    ElMessage.success('成功')
    isShowAdd.value = false
    fetchData(MI_params)
  })
}

// 修改
const modifyFg = ref<boolean>(false)
const modifyHandle = (row: any) => {
  MI_modifyForm(row, addConfig, modifyFg, async(params: any) => {
    await editApi({...params, id: row.id})
    ElMessage.success('修改成功')
    modifyFg.value = false
    fetchData(MI_params)
  })
}

// 删除
const delHandle = (row: any) => {
  ElMessageBox.confirm(`请确认是否删除: ${row.itemName}`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    MI_identify.value = true
    return delApi({id: row.id})

  }).then(() => {
    ElMessage.success('删除成功') 
    MI_identify.value = false
    fetchData()
  }).catch(() => {
    MI_identify.value = false
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addHandle())),
      class: "mb-10",
      type: "primary"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(fetchData)())),
      class: "mb-10",
      type: "info",
      icon: "refresh"
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      border: "",
      data: _unref(MI_tableData),
      style: {"width":"60%"},
      "max-height": _unref(MI_height)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "项目名称",
          prop: "itemName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "角色",
          prop: "roleId",
          width: "430"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, [
              (row.roleId.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.roleId, (roleItem) => {
                      return (_openBlock(), _createBlock(_component_el_tag, { class: "mr-5 mb-5 mt-5" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(rolesList).find((e) => e.id === roleItem )?.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 256))
                  ]))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (modifyHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (delHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowAdd.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isShowAdd).value = $event)),
      draggable: "",
      width: "600px",
      title: "新增项目"
    }, {
      default: _withCtx(() => [
        (isShowAdd.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modifyFg).value = $event)),
      draggable: "",
      width: "600px",
      title: "修改项目"
    }, {
      default: _withCtx(() => [
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})